
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rwg-bridge/signup",
      function () {
        return require("private-next-pages/rwg-bridge/signup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rwg-bridge/signup"])
      });
    }
  